export default "__VITE_ASSET__9d5608fc__"